import { SummaryApiRequest } from "@/data/payload/api/PosLeaderboard";
import { POSLeaderboardListRequest } from "@/data/payload/api/POSLeaderboardApiRequest";

export class POSLeaderboardEndpoint {
  getSummary(params: SummaryApiRequest): string {
    return `/hydra/v1/leaderboard/summary?${params.toQueryString()}`;
  }

  posLeaderboard(params: POSLeaderboardListRequest) {
    return '/hydra/v1/leaderboard/pos?'+params.toQueryString();
  }

  getConfig(params: SummaryApiRequest) {
    return '/hydra/v1/leaderboard/config?'+params.toQueryString();
  }
}
